import "@/firebaseSetup";

import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

import "@/assets/css/tailwind.css";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn:
      "https://dc9b05e74e8e49a0822587dbdfa4fa1d@o68807.ingest.sentry.io/5374989",
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

Vue.config.productionTip = process.env.NODE_ENV === "development";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
